import type { AnyChannelContract } from 'shared/channels/contract';

/**
 * Downloads running in this worker session, by the contract key of their
 * entity. In memory on purpose: a restarted worker runs none, whatever the
 * stored `isDownloading` says.
 */
const runningPullCounts = new Map<string, number>();

/** Marks a download of the entity as running; the returned function marks it ended. */
export function markPullRunning({ key }: AnyChannelContract): () => void {
  runningPullCounts.set(key, (runningPullCounts.get(key) ?? 0) + 1);
  let ended = false;
  return (): void => {
    if (ended) {
      return;
    }
    ended = true;
    const count = (runningPullCounts.get(key) ?? 1) - 1;
    if (count > 0) {
      runningPullCounts.set(key, count);
    } else {
      runningPullCounts.delete(key);
    }
  };
}

/** Whether a download of the entity runs now in this worker session. */
export function isPullRunning({ key }: AnyChannelContract): boolean {
  return runningPullCounts.has(key);
}
